<template>
	<div class="modal modal--xs" id="vacancy-form">
		<div class="modal-form">
			<div class="modal-form__title">Откликнуться на вакансию</div>
			<form class="form vacancy-form" v-if="formInitials" ref="vacancyForm">
				<div class="form__inputs">
					<div class="form__inputs-input">
						<div class="default-input">
							<label class="default-input__label">Город</label>
							<div class="default-select" :class="{'default-select--error' : v$.formData.city.$errors.length}">
								<Multiselect :label="'name'" @click.stop @mousedown.stop :options="filteredCities" v-model="formData.city" :track-by="'name'" :no-results-text="'Город не найден'" :placeholder="'Выберите город'" :can-clear="false" :can-deselect="false" :value-prop="'id'">
									<template #placeholder>
										<div class="multiselect-placeholder">
											<span>Выберите город</span>
										</div>
									</template>
								</Multiselect>
							</div>
							<div v-if="v$.formData.city.$errors.length" class="default-input__error">
								<span v-for="(error, index) in v$.formData.city.$errors" :key="index">{{
										error.$message
									}}</span>
							</div>
						</div>
					</div>
					<div class="form__inputs-input">
						<div class="default-input">
							<label class="default-input__label">Наименование вакансии</label>
							<div class="default-select" :class="{'default-select--error' : v$.formData.job.$errors.length}">
								<Multiselect :label="'name'" @click.stop @mousedown.stop :options="filteredVacancies" v-model="formData.job" :searchable="true" :track-by="'name'" :no-results-text="'Вакансия не найдена'" :placeholder="'Выберите вакансию'" :can-clear="false" :can-deselect="false" :value-prop="'id'">
									<template #placeholder>
										<div class="multiselect-placeholder">
											<span>Выберите вакансию</span></div>
									</template>
								</Multiselect>
							</div>
							<div v-if="v$.formData.job.$errors.length" class="default-input__error">
								<span v-for="(error, index) in v$.formData.job.$errors" :key="index">{{
										error.$message
									}}</span>
							</div>
						</div>
					</div>
					<div class="form__inputs-input">
						<div class="default-input">
							<label class="default-input__label" for="vacancyForm-name">Имя</label>
							<div class="default-input__input" :class="{'default-input__input--error' : v$.formData.fio.$errors.length}">
								<input v-model="formData.fio" type="text" inputmode="text" id="vacancyForm-name" placeholder="Иванов Иван" tabindex="0">
							</div>
							<div v-if="v$.formData.fio.$errors.length" class="default-input__error">
								<span v-for="(error, index) in v$.formData.fio.$errors" :key="index">{{
										error.$message
									}}</span>
							</div>
						</div>
					</div>
					<div class="form__inputs-input">
						<div class="default-input">
							<label class="default-input__label" for="vacancyForm-mail">E-mail</label>
							<div class="default-input__input" :class="{'default-input__input--error' : v$.formData.email.$errors.length}">
								<input v-model="formData.email" type="email" inputmode="email" id="vacancyForm-mail" placeholder="mail@gmail.com" tabindex="0">
							</div>
							<div v-if="v$.formData.email.$errors.length" class="default-input__error">
								<span v-for="(error, index) in v$.formData.email.$errors" :key="index">{{
										error.$message
									}}</span>
							</div>
						</div>
					</div>
					<div class="form__inputs-input">
						<div class="default-input">
							<label class="default-input__label" for="vacancyForm-phone">Телефон</label>
							<div class="default-input__input" :class="{'default-input__input--error' : v$.formData.phone.$errors.length}">
								<input v-model="formData.phone" type="tel" ref="inputPhone" placeholder="+7 (999) 549 34 95" v-mask="'+7 (999) 999 99 99'" id="vacancyForm-phone" inputmode="text" tabindex="0">
							</div>
							<div v-if="v$.formData.phone.$errors.length" class="default-input__error">
								<span v-for="(error, index) in v$.formData.phone.$errors" :key="index">{{
										error.$message
									}}</span>
							</div>
						</div>
					</div>
					<div class="form__inputs-input">
						<div class="default-input">
							<label class="default-input__label" for="vacancyForm-message">Сообщение</label>
							<div class="default-input__input" :class="{'default-input__input--error' : v$.formData.message.$errors.length}">
								<textarea v-model="formData.message" :placeholder="'Текст сообщения'" id="vacancyForm-message" tabindex="0"></textarea>
							</div>
							<div v-if="v$.formData.message.$errors.length" class="default-input__error">
								<span v-for="(error, index) in v$.formData.message.$errors" :key="index">{{ error.$message }}</span>
							</div>
						</div>
					</div>
					<div class="form__inputs-input">
						<div class="default-input">
							<span class="default-input__label">Прикрепить резюме</span>
							<div class="default-input__input default-input__input--file" :class="{'default-input__input--error' : v$.formData.resume.$errors.length}">
								<input class="inputfile" type="file" placeholder="doc, docx, pdf ..." @change="setFile" id="vacancyForm-resume" accept=".doc,.docx,.pdf" name="resume">
								<label class="inputfile__label" for="vacancyForm-resume"><span>{{
										formData.resume?.name || 'doc, docx, pdf ...'
									}}</span></label>
							</div>
							<div v-if="v$.formData.resume.$errors.length" class="default-input__error">
								<span v-for="(error, index) in v$.formData.resume.$errors" :key="index">{{ error.$message }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="vacancy-form__info">
					<div class="vacancy-form__info-text">
						<p>Если вам удобнее, вы можете отправить резюме и сопроводительное письмо на почту</p>
					</div>
					<div class="vacancy-form__info-email"><a href="mailto:mikar_ok@mail.ru">mikar_ok@mail.ru</a></div>
				</div>
				<div class="form__submit">
					<div class="form__submit-btn">
						<button class="btn color shadow" @click.prevent="sendForm">Отправить</button>
					</div>
					<div class="form__submit-text">
						<p>Нажимая кнопку, Вы даете информированное <a :href="documents['personal-data']" target="_blank">согласие</a>на обработку своих <a
							:href="documents['policy']" target="_blank">персональных данных</a></p>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Multiselect from "@vueform/multiselect";
import useVuelidate from "@vuelidate/core";
import {required, helpers, email, maxLength} from '@vuelidate/validators'
import {getCookie} from "@/utils/Cookie";

const {withMessage} = helpers
const maxSize = (param) => (value) => value ? value.size <= param * 1000 : true
export default {
	components: {Multiselect},
	name: "PopupVacancy",
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	data() {
		return {
			userDataTrigger: null,
			formData: {
				fio: '',
				job: '',
				city: getCookie('FIA_CITY_DATA') ? JSON.parse(getCookie('FIA_CITY_DATA')).id : '',
				phone: '',
				email: '',
				message: '',
				resume: null,
			}
		}
	},
	async mounted() {
		if (!this.formInitials) {
			await this.loadFormInitials()
		}
		this.setInitialData();
	},
	validations() {
		return {
			formData: {
				fio: {
					required: withMessage('Необходимо указать Имя', required),
					maxLength: withMessage('Максимальная длина поля 50 символов', maxLength(50)),
				},
				job: {
					required: withMessage('Необходимо выбрать вакансию', required),
				},
				city: {
					required: withMessage('Необходимо выбрать город', required),
				},
				phone: {
					required: withMessage('Необходимо указать телефон', required),
					maxLength: withMessage('Максимальная длина поля 50 символов', maxLength(50)),
				},
				email: {
					email: withMessage('Неверный формат электронной почты', email),
					required: withMessage('Необходимо указать E-mail', required),
					maxLength: withMessage('Максимальная длина поля 100 символов', maxLength(100)),
				},
				resume: {
					maxSize: withMessage('Превышен максимальный размер файла (5Mb)', maxSize(5000)),
					required: withMessage('Необходимо прикрепить резюме', required),
				},
				message: {
					required: withMessage('Необходимо указать информацию о себе', required),
					maxLength: withMessage('Максимальная длина поля 250 символов', maxLength(250)),
				},
			}
		}
	},
	computed: {
		...mapGetters({
			formInitials: 'vacancies/getFormInitials',
			documents: 'getDocuments',
			userData: 'user/getUserData',
		}),
		filteredVacancies () {
			let city = this.formInitials.cities.find(c => c.id == this.formData.city) || {};
			let cityName = (city.name || '').trim().toLowerCase();
			return this.formInitials.vacancies.filter(o => !o.cityName || !city || o.cityName.trim().toLowerCase() == cityName);
		},
		filteredCities () {
			let vacancyCities = this.formInitials.vacancies.map(v => v.cityName.trim().toLowerCase());
			return this.formInitials.cities.filter(city => ~vacancyCities.indexOf( city.name.trim().toLowerCase() ));
		},
	},
	methods: {
		setInitialData() {
			if (this.userData) {
				this.formData = {
					fio: this.userData.name,
					email: this.userData.email,
					message: '',
					phone: this.userData.phone,
					job: '',
					city: getCookie('FIA_CITY_DATA') ? JSON.parse(getCookie('FIA_CITY_DATA')).id : '',
					resume: null,
				}
			} else {
				this.formData = {
					fio: '',
					job: '',
					city: getCookie('FIA_CITY_DATA') ? JSON.parse(getCookie('FIA_CITY_DATA')).id : '',
					phone: '',
					email: '',
					message: '',
					resume: null,
				}
				if (!this.userDataTrigger) {
					this.userDataTrigger = this.$watch('userData', (newValue) => {
						this.formData = {
							fio: newValue.name,
							email: newValue.email,
							message: '',
							phone: newValue.phone,
							job: '',
							city: getCookie('FIA_CITY_DATA') ? JSON.parse(getCookie('FIA_CITY_DATA')).id : '',
							resume: null,
						}
						this.userDataTrigger();
					});
				}
			}
		},
		setFile(e) {
			if (e.target.files.length) {
				this.formData.resume = e.target.files[0]
			}
		},
		async sendForm() {
			this.loading = true
			const result = await this.v$.formData.$validate()
			if (!result) {
				this.loading = false
				return
			}

			// eslint-disable-next-line
			window.sendYM('stat-chastyu-komandy')


			let response = await this.sendVacancyForm({formData: this.formData})

			window.fancyboxConstructor.show([{src: "#popup-success", type: "inline"}], {
				Toolbar: false,
				dragToClose: false,
				Thumbs: false,
				closeButton: "top",
				mainClass: "fancybox-modal",
				on: {
					closing: () => {
						window.fancyboxConstructor.close()
					}
				}
			})

			if (response.success) {
				this.clearForm()
			}

			this.loading = false
		},
		clearForm() {
			this.setInitialData();
			this.$refs.vacancyForm.reset()
			this.v$.$reset()
		},
		...mapActions({
			sendVacancyForm: 'vacancies/sendVacancyForm',
			loadFormInitials: 'vacancies/loadFormInitials'
		})
	}
}
</script>

<style scoped>

</style>
